import React, { useState } from 'react';
import { RoundStakingStatus, StakingData } from '../../../web3/model/staking.model';
import { useConnectedUser, UserType } from '../../../context/connected-user.context';
import { CDKContract } from '../../../web3/contract';
import { toast } from 'react-toastify';
import { Button, Web3Button } from '../../../design-system/button';

export type GenericStakingActionsProps = {
    stackingRoundId: string,
    stackingRound: StakingData
}
export type StakingActionsProps = GenericStakingActionsProps & {
    userType: UserType;
}

export const StakingRoundUserActions: React.FC<{
    stackingRoundId: string;
    stackingRound: StakingData;
}> = (props) => {
    const connectedUserContext = useConnectedUser()!;
    const [cdkContract] = useState<CDKContract>(connectedUserContext.contract!);
    const [userAddress] = useState<string>(connectedUserContext.connectedUser!.walletAddress);
    const [cdkUserBalance] = useState<number>(connectedUserContext.connectedUser!.cdkBalance);
    const [cdkTokensForStaking, setCdkTokensForStaking] = useState<number>(0);

    const handleStakeTokens = () => {
        if (cdkTokensForStaking > 0) {
            if (cdkTokensForStaking > cdkUserBalance) {
                toast.error('Insufficient balance');
                return;
            }

            cdkContract.doStakeTokens(props.stackingRoundId, cdkTokensForStaking).then(() => {
                toast.success('Tokens staked successfully');
                connectedUserContext.reloadAllBalances();
            });
        }
    };

    return (
        <div className="flex flex-col justify-center">
            <div>
                <input
                    type="number"
                    min="0"
                    placeholder="CDK tokens to stake"
                    onChange={(e) => setCdkTokensForStaking(Number(e.target.value))}
                />
                <Button text="Stake tokens" onClick={handleStakeTokens} type="action" disabled={cdkTokensForStaking <= 0} />
            </div>
            <div>
                <Web3Button text="Claim reward" web3Action={() => cdkContract.stakingFacet.doClaimRewards(props.stackingRoundId)} />
            </div>
            <div>
                <Web3Button text="Compund reward" web3Action={() => cdkContract.stakingFacet.doCompoundRewards(props.stackingRoundId)} />
            </div>
            <div>
                <Web3Button
                    text="Withdraw CDK tokens"
                    web3Action={() => cdkContract.stakingFacet.doWithdrawTokens(props.stackingRoundId, userAddress)}
                />
            </div>
            <div>
                <Web3Button
                    text="Withdraw CDK tokens and claim reward"
                    web3Action={() => cdkContract.stakingFacet.doWithdrawAndClaimRewards(props.stackingRoundId)}
                />
            </div>
        </div>
    );
};
